import _ from 'underscore';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

export function instrument(operation, data) {
  switch (operation) {
  case 'create': {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'createAdgroup', '1');
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'createKeyword', _.size(data.Keywords));
    break;
  }
  case 'update': {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'updateAdgroup', '1');
    const deletedKeywordsCount = _.size(_.where(data.Keywords, {Status: 'Deleted'}));
    const createdKeywordsCount = _.size(data.Keywords) - deletedKeywordsCount;

    if (deletedKeywordsCount > 0) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'deleteKeyword', deletedKeywordsCount);
    }
    if (createdKeywordsCount > 0) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'createKeyword', createdKeywordsCount);
    }
    break;
  }
  case 'delete': {
    instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'deleteAdgroup', '1');
    break;
  }
  case 'save': {
    const deletedKeywordsCount = _.size(_.where(data.Keywords, {Status: 'Deleted'}));
    const createdKeywordsCount = _.size(data.Keywords) - deletedKeywordsCount;

    if (deletedKeywordsCount > 0) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'deleteKeyword', deletedKeywordsCount);
    }
    if (createdKeywordsCount > 0) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'createKeyword', createdKeywordsCount);
    }
    break;
  }
  default:
  }
}
